<template>
  <q-layout view="lHh Lpr lFf">
    <div
      class="flex w-full min-h-screen relative"
      :class="
        impersonatedUser
          ? 'sticky border-8 border-blue-600 box-border bg-transparent w-screen h-screen z-60'
          : ''
      "
    >
      <ImpersonateBanner v-if="impersonatedUser" />
      <div class="flex flex-col h-full w-full">
        <ConsumptionBanner
          ref="consumptionBannerRef"
          v-if="
            !impersonatedUser &&
            permissionStore.checkUserAccess('app.customer.api:usage_summary')
          "
        />
        <div
          class="inline-flex w-full relative"
          :style="`height: calc(100vh - ${
            consumptionBannerRef?.showBanner ? '40px' : '0px'
          })`"
        >
          <!-- SIDEBAR -->
          <SidebarNavigation />
          <!-- MAIN CONTENT -->
          <main
            class="flex-grow bg-white min-w-[0] overflow-x-hidden relative min-h-full"
          >
            <q-page-container class="h-full w-full">
              <RouterView v-slot="{ Component }">
                <transition name="fade" mode="out-in" :duration="150">
                  <component
                    :is="Component"
                    :key="route.path"
                    class="bg-neutral-surface-subtle !min-h-full"
                  />
                </transition>
              </RouterView>
            </q-page-container>
          </main>
        </div>
      </div>
    </div>
  </q-layout>
</template>
<script setup lang="ts">
import SidebarNavigation from './sidebar/SidebarNavigation.vue';
import ImpersonateBanner from 'src/core/components/layouts/ImpersonateBanner.vue';
import ConsumptionBanner from 'src/core/components/layouts/ConsumptionBanner.vue';
import { RouterView, useRoute } from 'vue-router';
import { useUserStore } from 'src/core/stores/user';
import { usePermissionStore } from 'src/core/stores/permission';
import { ref } from 'vue';

const userStore = useUserStore();
const permissionStore = usePermissionStore();
const impersonatedUser = userStore.user?.impersonated_by;
const consumptionBannerRef = ref<any>(null);

const route = useRoute();
</script>
